import { applyAetherEvent, parseSseEvent } from './aetherSseParse.js'
import { buildAetherBlocks } from './aetherProjectBlocks.js'

function drainSseBuffer(acc, buffer, final = false) {
  let next = buffer
  let boundary = next.indexOf('\n\n')
  while (boundary >= 0) {
    applyAetherEvent(acc, parseSseEvent(next.slice(0, boundary)))
    next = next.slice(boundary + 2)
    boundary = next.indexOf('\n\n')
  }
  if (final && next.trim()) {
    applyAetherEvent(acc, parseSseEvent(next))
    return ''
  }
  return next
}

export async function readAetherStream(response) {
  const reader = response.body?.getReader()
  if (!reader) return { text: await response.text(), meta: {} }

  const decoder = new TextDecoder()
  const acc = { text: '', error: '', meta: {}, files: new Map(), project: null }
  let buffer = ''

  while (true) {
    const { value, done } = await reader.read()
    if (done) break
    buffer += decoder.decode(value, { stream: true })
    buffer = drainSseBuffer(acc, buffer)
  }

  drainSseBuffer(acc, buffer, true)
  const text = acc.text.trim()
  if (acc.error) return { error: acc.error, text, meta: acc.meta }
  const blocks = buildAetherBlocks(text, acc.files, acc.project)
  return { text, meta: acc.meta, blocks }
}
